import { render } from "./Admin.vue?vue&type=template&id=55e03926&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=55e03926&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\Normann\\Configurator Dashboard\\normann-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e03926"]])

export default __exports__